import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-6 shadow" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap justify-content-between" }
const _hoisted_4 = { class: "me-5" }
const _hoisted_5 = { class: "me-0 mb-0 text-end" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex overflow-auto h-55px" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }, [
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link text-active-primary me-6 active",
        href: "#tabs_edit_general",
        "data-bs-toggle": "tab"
      }, "Thông dự án chung")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link text-active-primary me-6",
        href: "#tabs_edit_content",
        "data-bs-toggle": "tab"
      }, "Nội dung")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link text-active-primary me-6",
        href: "#tabs_edit_utility",
        "data-bs-toggle": "tab"
      }, "Tiện ích")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link text-active-primary me-6",
        href: "#tabs_edit_master_plan",
        "data-bs-toggle": "tab"
      }, "Mặt bằng")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link text-active-primary me-6",
        href: "#tabs_edit_seo",
        "data-bs-toggle": "tab"
      }, "SEO")
    ])
  ])
], -1)
const _hoisted_8 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_9 = { class: "card-body pt-10" }
const _hoisted_10 = { class: "tab-content" }
const _hoisted_11 = {
  class: "tab-pane fade active show",
  id: "tabs_edit_general",
  item: "tabpanel"
}
const _hoisted_12 = { class: "my-5 px-8" }
const _hoisted_13 = { class: "row g-9 mb-8" }
const _hoisted_14 = { class: "col-md-8 fv-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Tên dự án", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Đường dẫn dự án", -1)
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-12 fv-row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Địa chỉ", -1)
const _hoisted_20 = { class: "col-md-6 fv-row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Tỉnh/Thành Phố", -1)
const _hoisted_22 = { class: "col-md-6 fv-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Quận/Huyện", -1)
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-6 fv-row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Phường/Xã", -1)
const _hoisted_27 = { class: "col-md-6 fv-row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Đường", -1)
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-6 fv-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Giá bán cao nhất", -1)
const _hoisted_32 = { class: "col-md-6 fv-row" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Giá bán thấp nhất", -1)
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-12 fv-row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Danh mục dự án", -1)
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-6 fv-row" }
const _hoisted_39 = { class: "col-md-6 fv-row" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "demonstration required" }, "Chọn ngày đăng bài", -1)
const _hoisted_41 = { class: "date-picker" }
const _hoisted_42 = { class: "block" }
const _hoisted_43 = { class: "col-md-4 fv-row" }
const _hoisted_44 = { class: "d-flex justify-content-between" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Ảnh đại diện ", -1)
const _hoisted_46 = { class: "svg-icon svg-icon-2" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "d-flex justify-content-between" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h3", null, "Slides Ảnh", -1)
const _hoisted_51 = { class: "svg-icon svg-icon-2" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "image-input image-galleries p-4 image-input-outline m-2 w-100" }
const _hoisted_55 = {
  class: "image-input-wrapper h-150px w-100",
  style: `width:299px;`
}
const _hoisted_56 = ["src"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-3 text-white" }, null, -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "col-md-12" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Video giới thiệu")
], -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 fv-row mt-0" }, null, -1)
const _hoisted_63 = {
  class: "tab-pane fade",
  id: "tabs_edit_content",
  item: "tabpanel"
}
const _hoisted_64 = { class: "my-5 px-8" }
const _hoisted_65 = { class: "row g-9 mb-8" }
const _hoisted_66 = { class: "col-md-12 fv-row mt-1" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Tổng quan")
], -1)
const _hoisted_68 = { class: "col-md-6 editor-420" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Nội dung banner")
], -1)
const _hoisted_70 = { class: "col-md-6" }
const _hoisted_71 = { class: "d-flex justify-content-between" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("h3", null, "Ảnh banner", -1)
const _hoisted_73 = { class: "svg-icon svg-icon-2" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_75 = ["src"]
const _hoisted_76 = { class: "col-md-6 fv-row mt-1 mt-5" }
const _hoisted_77 = { class: "d-flex justify-content-between" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("h3", null, "Tiến độ thanh toán", -1)
const _hoisted_79 = { class: "svg-icon svg-icon-2" }
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_81 = ["src"]
const _hoisted_82 = { class: "col-md-6 fv-row mt-1 mt-5" }
const _hoisted_83 = { class: "d-flex justify-content-between" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("h3", null, "Chính sách bán hàng", -1)
const _hoisted_85 = { class: "svg-icon svg-icon-2" }
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_87 = ["src"]
const _hoisted_88 = {
  class: "tab-pane fade",
  id: "tabs_edit_utility",
  item: "tabpanel"
}
const _hoisted_89 = { class: "row" }
const _hoisted_90 = { class: "col-md-12 mb-5" }
const _hoisted_91 = { class: "d-flex justify-content-between" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-2 mb-2" }, "Galleries Ảnh tiện ích", -1)
const _hoisted_93 = { class: "svg-icon svg-icon-2" }
const _hoisted_94 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_95 = { class: "d-flex" }
const _hoisted_96 = { class: "image-input image-galleries p-4 image-input-outline m-2 w-100" }
const _hoisted_97 = {
  class: "image-input-wrapper h-150px w-100",
  style: `width:299px;`
}
const _hoisted_98 = ["src"]
const _hoisted_99 = ["onClick"]
const _hoisted_100 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-3 text-white" }, null, -1)
const _hoisted_101 = [
  _hoisted_100
]
const _hoisted_102 = { class: "row" }
const _hoisted_103 = { class: "col-md-12 fv-row mt-1 editor-420" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "MÔ TẢ tiện ích")
], -1)
const _hoisted_105 = { class: "row mt-2 mb-2 mt-5" }
const _hoisted_106 = { class: "col-md-6 editor-420" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Tiện ích khu vực")
], -1)
const _hoisted_108 = { class: "col-md-6" }
const _hoisted_109 = { class: "d-flex justify-content-between" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("h3", null, "Ảnh tiện ích khu vực", -1)
const _hoisted_111 = { class: "svg-icon svg-icon-2" }
const _hoisted_112 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_113 = ["src"]
const _hoisted_114 = { class: "row mt-2 mb-2" }
const _hoisted_115 = { class: "col-md-6 editor-420" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Vị trí dự án")
], -1)
const _hoisted_117 = { class: "col-md-6" }
const _hoisted_118 = { class: "d-flex justify-content-between" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("h3", null, "Ảnh vị trí dự án", -1)
const _hoisted_120 = { class: "svg-icon svg-icon-2" }
const _hoisted_121 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_122 = ["src"]
const _hoisted_123 = {
  class: "tab-pane fade",
  id: "tabs_edit_master_plan",
  item: "tabpanel"
}
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb-5" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
      /*#__PURE__*/_createElementVNode("h3", null, "Mặt bằng tổng thể dự án")
    ])
  ])
], -1)
const _hoisted_125 = { class: "row" }
const _hoisted_126 = { class: "col-md-12 fv-row mt-1 editor-420" }
const _hoisted_127 = { class: "row my-5 border-top pt-4 border-active-primary" }
const _hoisted_128 = { class: "d-flex justify-content-between" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("h3", null, "Danh sách tòa nhà", -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle fs-4" }),
  /*#__PURE__*/_createTextVNode(" Thêm tòa nhà ")
], -1)
const _hoisted_131 = [
  _hoisted_130
]
const _hoisted_132 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb-5" }, null, -1)
const _hoisted_133 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, [
      /*#__PURE__*/_createElementVNode("h4", null, "Tên toàn nhà")
    ])
  ])
], -1)
const _hoisted_134 = { class: "row" }
const _hoisted_135 = { class: "col-md-8" }
const _hoisted_136 = { class: "col-md-1" }
const _hoisted_137 = ["onClick"]
const _hoisted_138 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-dash-circle fs-4" }, null, -1)
const _hoisted_139 = [
  _hoisted_138
]
const _hoisted_140 = { class: "col-md-3" }
const _hoisted_141 = ["onClick"]
const _hoisted_142 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle fs-4" }),
  /*#__PURE__*/_createTextVNode(" Thêm căn hộ ")
], -1)
const _hoisted_143 = [
  _hoisted_142
]
const _hoisted_144 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "d-flex align-items-center my-5" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Danh sách căn hộ")
  ])
], -1)
const _hoisted_145 = { class: "row my-5" }
const _hoisted_146 = { class: "position-relative border p-4" }
const _hoisted_147 = { class: "d-flex justify-content-between" }
const _hoisted_148 = ["onClick"]
const _hoisted_149 = { class: "svg-icon svg-icon-2" }
const _hoisted_150 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_151 = ["src"]
const _hoisted_152 = ["onClick"]
const _hoisted_153 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-4" }, null, -1)
const _hoisted_154 = [
  _hoisted_153
]
const _hoisted_155 = { class: "row" }
const _hoisted_156 = { class: "col-md-12 mb-5" }
const _hoisted_157 = { class: "d-flex justify-content-between" }
const _hoisted_158 = /*#__PURE__*/_createElementVNode("h3", null, "HÌNH ẢNH CĂN HỘ MẪU", -1)
const _hoisted_159 = { class: "svg-icon svg-icon-2" }
const _hoisted_160 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_161 = { class: "d-flex" }
const _hoisted_162 = { class: "image-input image-galleries p-4 image-input-outline m-2 w-100" }
const _hoisted_163 = {
  class: "image-input-wrapper h-150px w-100",
  style: `width:299px;`
}
const _hoisted_164 = ["src"]
const _hoisted_165 = ["onClick"]
const _hoisted_166 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-3 text-white" }, null, -1)
const _hoisted_167 = [
  _hoisted_166
]
const _hoisted_168 = {
  class: "tab-pane fade",
  id: "tabs_edit_seo",
  item: "tabpanel"
}
const _hoisted_169 = { class: "d-flex flex-column px-9" }
const _hoisted_170 = { class: "row g-9 mb-8" }
const _hoisted_171 = { class: "col-md-12 fv-row" }
const _hoisted_172 = /*#__PURE__*/_createElementVNode("h3", null, "Từ khóa seo", -1)
const _hoisted_173 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Robots", -1)
const _hoisted_174 = /*#__PURE__*/_createElementVNode("h3", null, "Tiêu đề seo", -1)
const _hoisted_175 = /*#__PURE__*/_createElementVNode("h3", null, "Nội dung seo", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_editor = _resolveComponent("editor")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    id: "add_project_form",
    model: _ctx.objectData,
    rules: _ctx.rules,
    ref: "formRef",
    class: "form"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_affix, { offset: 120 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.objectData.name), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      class: "btn-primary btn",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit())),
                      loading: _ctx.loading
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.loading ? "Đang xử lý..." : "Lưu lại"), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ])
              ]),
              _hoisted_7
            ])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_el_form_item, { prop: "name" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.convertNameToSlug(_ctx.objectData.name))),
                          modelValue: _ctx.objectData.name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objectData.name) = $event)),
                          placeholder: "Tiêu đề dự án",
                          name: "name"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_16,
                    _createVNode(_component_el_form_item, { prop: "slug" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.slug,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objectData.slug) = $event)),
                          placeholder: "Đường dẫn dự án sẽ được tạo tự động từ tiêu đề",
                          name: "slug"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createVNode(_component_el_form_item, { prop: "address" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.objectData.address,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.objectData.address) = $event)),
                              name: "address"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createVNode(_component_el_form_item, { prop: "location.province_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              "data-is-search": "true",
                              modelValue: _ctx.objectData.location.province_id,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.objectData.location.province_id) = $event)),
                              "default-first-option": "",
                              placeholder: "Chọn Tỉnh/Thành Phố",
                              onChange: _cache[6] || (_cache[6] = ($event: any) => (
                            _ctx.onChangeLocation(_ctx.objectData.location.province_id)
                          )),
                              rules: [
                            {
                              required: true,
                              message: 'Chọn thỉnh thành',
                              trigger: 'blur',
                            },
                          ]
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataProvince, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item._id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createVNode(_component_el_form_item, { prop: "location.district_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              "data-is-search": "true",
                              modelValue: _ctx.objectData.location.district_id,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.objectData.location.district_id) = $event)),
                              "default-first-option": "",
                              placeholder: "Chọn Quận/Huyện",
                              onChange: _cache[8] || (_cache[8] = ($event: any) => (
                            _ctx.onChangeDistrict(_ctx.objectData.location.district_id)
                          ))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataDistrict, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item._id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createVNode(_component_el_form_item, { prop: "location.ward_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              "data-is-search": "true",
                              modelValue: _ctx.objectData.location.ward_id,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.objectData.location.ward_id) = $event)),
                              "default-first-option": "",
                              placeholder: "Chọn Phường/Xã",
                              onChange: _ctx.onChangeWard
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataWard, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item._id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createVNode(_component_el_form_item, { prop: "location.street_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              "data-is-search": "true",
                              modelValue: _ctx.objectData.location.street_id,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.objectData.location.street_id) = $event)),
                              "default-first-option": "",
                              placeholder: "Chọn Đường",
                              onChange: _ctx.onChangeStreet
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataStreet, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item._id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createVNode(_component_el_form_item, { prop: "price_max" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onChangePriceMax(_ctx.objectData.price_max))),
                              type: "number",
                              modelValue: _ctx.objectData.price_max,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.objectData.price_max) = $event)),
                              placeholder: "Giá cao nhất"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createVNode(_component_el_form_item, { prop: "price_min" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onChangePriceMin(_ctx.objectData.price_min))),
                              type: "number",
                              modelValue: _ctx.objectData.price_min,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.objectData.price_min) = $event)),
                              placeholder: "Giá thấp nhất"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createVNode(_component_el_form_item, { prop: "categories" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.objectData.categories,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.objectData.categories) = $event)),
                              multiple: "",
                              filterable: "",
                              "allow-create": "",
                              "default-first-option": "",
                              placeholder: "Danh mục dự án"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataCategory, (item, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    _createVNode(_component_el_option, {
                                      label: item.name,
                                      value: item._id
                                    }, null, 8, ["label", "value"]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, ind) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: ind }, [
                                        (child.name)
                                          ? (_openBlock(), _createBlock(_component_el_option, {
                                              key: 0,
                                              label: '-- ' + child.name,
                                              value: child._id
                                            }, null, 8, ["label", "value"]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 128))
                                  ], 64))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_el_form_item, { label: "Trạng thái hiển thị" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_switch, {
                              modelValue: _ctx.objectData.status,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.objectData.status) = $event)),
                              "active-color": "#13ce66",
                              "inactive-color": "#ff4949",
                              "active-value": "active",
                              "inactive-value": "inactive"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "Hiển thị trang chủ" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_switch, {
                              modelValue: _ctx.objectData.home,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.objectData.home) = $event)),
                              "active-color": "#13ce66",
                              "inactive-color": "#ff4949"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createVNode(_component_el_form_item, { prop: "published_at" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_date_picker, {
                                  modelValue: _ctx.objectData.published_at,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.objectData.published_at) = $event)),
                                  type: "date",
                                  placeholder: "Chọn ngày",
                                  "disabled-date": _ctx.disabledDate
                                }, null, 8, ["modelValue", "disabled-date"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showSingleMedia('thumbnail'))),
                        class: "btn btn-primary btn-sm end",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end"
                      }, [
                        _createElementVNode("span", _hoisted_46, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                          _hoisted_47
                        ])
                      ])
                    ]),
                    _createVNode(_component_el_form_item, {
                      prop: "image",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          style: {"width":"100%"},
                          src: _ctx.renderImageUrl(_ctx.objectData.thumbnail, 'thumbnail'),
                          alt: ""
                        }, null, 8, _hoisted_48)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showMultipleMedia('galleries'))),
                        class: "btn btn-primary btn-sm end",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end"
                      }, [
                        _createElementVNode("span", _hoisted_51, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                          _hoisted_52
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectData.galleries, (img, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "col-md-6"
                        }, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("img", {
                                class: "w-100",
                                style: {"object-fit":"cover","height":"150px"},
                                src: _ctx.renderImageUrl(img, 'thumbnail'),
                                alt: ""
                              }, null, 8, _hoisted_56)
                            ]),
                            _createElementVNode("label", {
                              class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-danger shadow",
                              "data-kt-image-input-action": "change",
                              "data-bs-toggle": "tooltip",
                              onClick: ($event: any) => (
                              _ctx.removeImages({ name: 'galleries', index: index })
                            )
                            }, _hoisted_59, 8, _hoisted_57)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _hoisted_61,
                      _createVNode(_component_el_form_item, { prop: "video" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.objectData.video,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.objectData.video) = $event)),
                            placeholder: "Đường dẫn video"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _hoisted_62
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createVNode(_component_editor, {
                      "api-key": "eik426uetuniwvflvp9ffcqc9kr6j4bt8lgskfghdki0lsjf",
                      modelValue: _ctx.objectData.content,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.objectData.content) = $event)),
                      init: _ctx.editorConfig
                    }, null, 8, ["modelValue", "init"])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _hoisted_69,
                    _createVNode(_component_editor, {
                      "api-key": "eik426uetuniwvflvp9ffcqc9kr6j4bt8lgskfghdki0lsjf",
                      modelValue: _ctx.objectData.banner.text,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.objectData.banner.text) = $event)),
                      init: _ctx.editorConfig
                    }, null, 8, ["modelValue", "init"])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _hoisted_72,
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showSingleMedia('banner.image'))),
                        class: "btn btn-primary btn-sm end",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end"
                      }, [
                        _createElementVNode("span", _hoisted_73, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                          _hoisted_74
                        ])
                      ])
                    ]),
                    _createVNode(_component_el_form_item, {
                      prop: "image",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          style: {"width":"100%"},
                          src: 
                        _ctx.renderImageUrl(_ctx.objectData.banner.image, 'thumbnail')
                      ,
                          alt: ""
                        }, null, 8, _hoisted_75)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, [
                      _hoisted_78,
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.showSingleMedia('payment_schedule_image'))),
                        class: "btn btn-primary btn-sm end",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end"
                      }, [
                        _createElementVNode("span", _hoisted_79, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                          _hoisted_80
                        ])
                      ])
                    ]),
                    _createVNode(_component_el_form_item, {
                      prop: "image",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          style: {"width":"100%"},
                          src: 
                        _ctx.renderImageUrl(_ctx.objectData.payment_schedule_image, 'payment_schedule_image')
                      ,
                          alt: ""
                        }, null, 8, _hoisted_81)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      _hoisted_84,
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showSingleMedia('policy_image'))),
                        class: "btn btn-primary btn-sm end",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end"
                      }, [
                        _createElementVNode("span", _hoisted_85, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                          _hoisted_86
                        ])
                      ])
                    ]),
                    _createVNode(_component_el_form_item, {
                      prop: "image",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          style: {"width":"100%"},
                          src: 
                        _ctx.renderImageUrl(_ctx.objectData.policy_image, 'policy_image')
                      ,
                          alt: ""
                        }, null, 8, _hoisted_87)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("div", _hoisted_91, [
                    _hoisted_92,
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showMultipleMedia('utility.images'))),
                      class: "btn btn-primary btn-sm end",
                      "data-kt-menu-trigger": "click",
                      "data-kt-menu-placement": "bottom-end",
                      "data-kt-menu-flip": "top-end"
                    }, [
                      _createElementVNode("span", _hoisted_93, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                        _hoisted_94
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_95, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectData.utility.images, (img, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-md-2"
                      }, [
                        _createElementVNode("div", _hoisted_96, [
                          _createElementVNode("div", _hoisted_97, [
                            _createElementVNode("img", {
                              class: "w-100",
                              style: {"object-fit":"cover","height":"150px"},
                              src: _ctx.renderImageUrl(img, 'thumbnail'),
                              alt: ""
                            }, null, 8, _hoisted_98)
                          ]),
                          _createElementVNode("label", {
                            class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-danger shadow",
                            "data-kt-image-input-action": "change",
                            "data-bs-toggle": "tooltip",
                            onClick: ($event: any) => (
                            _ctx.removeImages({
                              name: 'utility.images',
                              index: index,
                            })
                          )
                          }, _hoisted_101, 8, _hoisted_99)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("div", _hoisted_103, [
                  _hoisted_104,
                  _createVNode(_component_editor, {
                    "api-key": "eik426uetuniwvflvp9ffcqc9kr6j4bt8lgskfghdki0lsjf",
                    modelValue: _ctx.objectData.utility.text,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.objectData.utility.text) = $event)),
                    init: _ctx.editorConfig
                  }, null, 8, ["modelValue", "init"])
                ])
              ]),
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("div", _hoisted_106, [
                  _hoisted_107,
                  _createVNode(_component_editor, {
                    "api-key": "eik426uetuniwvflvp9ffcqc9kr6j4bt8lgskfghdki0lsjf",
                    modelValue: _ctx.objectData.utility_area.text,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.objectData.utility_area.text) = $event)),
                    init: _ctx.editorConfig
                  }, null, 8, ["modelValue", "init"])
                ]),
                _createElementVNode("div", _hoisted_108, [
                  _createElementVNode("div", _hoisted_109, [
                    _hoisted_110,
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showSingleMedia('utility_area.image'))),
                      class: "btn btn-primary btn-sm end",
                      "data-kt-menu-trigger": "click",
                      "data-kt-menu-placement": "bottom-end",
                      "data-kt-menu-flip": "top-end"
                    }, [
                      _createElementVNode("span", _hoisted_111, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                        _hoisted_112
                      ])
                    ])
                  ]),
                  _createVNode(_component_el_form_item, {
                    prop: "image",
                    class: "mt-4"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        style: {"width":"100%"},
                        src: 
                      _ctx.renderImageUrl(
                        _ctx.objectData.utility_area.image,
                        '300',
                        '200'
                      )
                    ,
                        alt: ""
                      }, null, 8, _hoisted_113)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("div", _hoisted_115, [
                  _hoisted_116,
                  _createVNode(_component_editor, {
                    "api-key": "eik426uetuniwvflvp9ffcqc9kr6j4bt8lgskfghdki0lsjf",
                    modelValue: _ctx.objectData.place.text,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.objectData.place.text) = $event)),
                    init: _ctx.editorConfig
                  }, null, 8, ["modelValue", "init"])
                ]),
                _createElementVNode("div", _hoisted_117, [
                  _createElementVNode("div", _hoisted_118, [
                    _hoisted_119,
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.showSingleMedia('place.image'))),
                      class: "btn btn-primary btn-sm end",
                      "data-kt-menu-trigger": "click",
                      "data-kt-menu-placement": "bottom-end",
                      "data-kt-menu-flip": "top-end"
                    }, [
                      _createElementVNode("span", _hoisted_120, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                        _hoisted_121
                      ])
                    ])
                  ]),
                  _createVNode(_component_el_form_item, {
                    prop: "image",
                    class: "mt-4"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        style: {"width":"100%"},
                        src: _ctx.renderImageUrl(_ctx.objectData.place.image, 'thumbnail'),
                        alt: ""
                      }, null, 8, _hoisted_122)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_123, [
              _hoisted_124,
              _createElementVNode("div", _hoisted_125, [
                _createElementVNode("div", _hoisted_126, [
                  _createVNode(_component_editor, {
                    "api-key": "eik426uetuniwvflvp9ffcqc9kr6j4bt8lgskfghdki0lsjf",
                    modelValue: _ctx.objectData.master_plan.description,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.objectData.master_plan.description) = $event)),
                    init: _ctx.editorConfig
                  }, null, 8, ["modelValue", "init"])
                ])
              ]),
              _createElementVNode("div", _hoisted_127, [
                _createElementVNode("div", _hoisted_128, [
                  _hoisted_129,
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.addBuilding())),
                    class: "btn btn-primary btn-sm end",
                    "data-kt-menu-trigger": "click",
                    "data-kt-menu-placement": "bottom-end",
                    "data-kt-menu-flip": "top-end"
                  }, _hoisted_131)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectData.master_plan.buildings, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _hoisted_132,
                  _hoisted_133,
                  _createElementVNode("div", _hoisted_134, [
                    _createElementVNode("div", _hoisted_135, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.objectData.master_plan.buildings[index].name,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.objectData.master_plan.buildings[index].name) = $event),
                        placeholder: "Nhập tên tòa nhà",
                        name: "name"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_136, [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-danger rounded",
                        type: "button",
                        onClick: ($event: any) => (_ctx.removeBuilding(index))
                      }, _hoisted_139, 8, _hoisted_137)
                    ]),
                    _createElementVNode("div", _hoisted_140, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (_ctx.addApartment(index)),
                        class: "btn btn-primary btn-sm end",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end"
                      }, _hoisted_143, 8, _hoisted_141)
                    ]),
                    _hoisted_144
                  ]),
                  _createElementVNode("div", _hoisted_145, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectData.master_plan
                    .buildings[index].apartments, (item, apartmentIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: apartmentIndex,
                        class: "col-md-3 mb-5"
                      }, [
                        _createElementVNode("div", _hoisted_146, [
                          _createVNode(_component_el_form_item, { class: "my-3" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: 
                            _ctx.objectData.master_plan.buildings[index].apartments[
                              apartmentIndex
                            ].name
                          ,
                                "onUpdate:modelValue": ($event: any) => ((
                            _ctx.objectData.master_plan.buildings[index].apartments[
                              apartmentIndex
                            ].name
                          ) = $event),
                                placeholder: "Nhập tên căn hộ",
                                name: "name"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_147, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (
                            _ctx.showSingleMedia(
                              `master_plan.buildings.${index}.apartments.${apartmentIndex}.image`
                            )
                          ),
                              class: "btn btn-primary btn-sm end",
                              "data-kt-menu-trigger": "click",
                              "data-kt-menu-placement": "bottom-end",
                              "data-kt-menu-flip": "top-end"
                            }, [
                              _createElementVNode("span", _hoisted_149, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                                _hoisted_150
                              ])
                            ], 8, _hoisted_148)
                          ]),
                          _createVNode(_component_el_form_item, {
                            prop: "image",
                            class: "mt-4"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                style: {"width":"100%"},
                                src: 
                            _ctx.renderImageUrl(
                              _ctx.objectData.master_plan.buildings[index]
                                .apartments[apartmentIndex].image,
                              '300',
                              '200'
                            )
                          ,
                                alt: ""
                              }, null, 8, _hoisted_151)
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("button", {
                            style: {"right":"-10px","top":"-10px"},
                            class: "btn btn-sm btn-danger position-absolute right-0 btn-circle btn btn-icon",
                            type: "button",
                            onClick: ($event: any) => (_ctx.removeApartment(index, apartmentIndex))
                          }, _hoisted_154, 8, _hoisted_152)
                        ])
                      ]))
                    }), 128))
                  ])
                ], 64))
              }), 128)),
              _createElementVNode("div", _hoisted_155, [
                _createElementVNode("div", _hoisted_156, [
                  _createElementVNode("div", _hoisted_157, [
                    _hoisted_158,
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.showMultipleMedia('images_apartment'))),
                      class: "btn btn-primary btn-sm end",
                      "data-kt-menu-trigger": "click",
                      "data-kt-menu-placement": "bottom-end",
                      "data-kt-menu-flip": "top-end"
                    }, [
                      _createElementVNode("span", _hoisted_159, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                        _hoisted_160
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_161, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectData.images_apartment, (img, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-md-2"
                      }, [
                        _createElementVNode("div", _hoisted_162, [
                          _createElementVNode("div", _hoisted_163, [
                            _createElementVNode("img", {
                              class: "w-100",
                              style: {"object-fit":"cover","height":"150px"},
                              src: _ctx.renderImageUrl(img, 'thumbnail'),
                              alt: ""
                            }, null, 8, _hoisted_164)
                          ]),
                          _createElementVNode("label", {
                            class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-danger shadow",
                            "data-kt-image-input-action": "change",
                            "data-bs-toggle": "tooltip",
                            onClick: ($event: any) => (
                            _ctx.removeImages({
                              name: 'images_apartment',
                              index: index,
                            })
                          )
                          }, _hoisted_167, 8, _hoisted_165)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_168, [
              _createElementVNode("div", _hoisted_169, [
                _createElementVNode("div", _hoisted_170, [
                  _createElementVNode("div", _hoisted_171, [
                    _hoisted_172,
                    _createVNode(_component_el_form_item, { prop: "seo.keywords" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.seo.keywords,
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.objectData.seo.keywords) = $event)),
                          name: "keyword"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_173,
                    _createVNode(_component_el_form_item, { prop: "robot" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.objectData.seo.robot,
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.objectData.seo.robot) = $event)),
                          placeholder: "",
                          name: "robot"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "index, follow",
                              value: "index, follow"
                            }),
                            _createVNode(_component_el_option, {
                              label: "index, nofollow",
                              value: "index, nofollow"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_174,
                    _createVNode(_component_el_form_item, { prop: "seo.title" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.seo.title,
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.objectData.seo.title) = $event)),
                          placeholder: "",
                          name: "seo_title"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_175,
                    _createVNode(_component_el_form_item, { prop: "seo.description" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.seo.description,
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.objectData.seo.description) = $event)),
                          placeholder: "",
                          name: "seo_des",
                          rows: "4",
                          type: "textarea"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}